<template lang="pug">
.flex
  SchedulerSelector(
    v-for="{ title, description, name, eventName } in schedulingOptions"
    :description="description"
    :title="title"
    :selected="selectorIsSelected(name)"
    :disabled="selectorIsDisabled(name)"
    :type="name"
    :key="name"
    @selected="p => $emit(eventName, p)"
    )
</template>

<script>
import SchedulerSelector from './SchedulerSelector.vue'

export default {
  name: 'ProductSchedulingOptions',
  components: {
    SchedulerSelector,
  },
  props: {
    selectorAvailability: Object,
    disabled: Boolean,
    isParallelProduct: Boolean,
    schedulingBehavior: String,
    isSequential: Boolean,
  },
  data() {
    return {
      schedulingOptions: [
        {
          title: 'Sequential',
          name: 'sequential',
          description: 'This product is scheduled before/after another product.',
          eventName: 'selectSequential',
        },
        {
          title: 'Parallel',
          name: 'parallel',
          description: 'This product is scheduled in parallel to other scheduled products.',
          eventName: 'selectSchedulingBehavior',
        },
        {
          title: 'Non-Scheduled',
          name: 'noDuration',
          description: 'This product will not be scheduled and has no duration.',
          eventName: 'selectSchedulingBehavior',
        },
      ],
    }
  },
  methods: {
    selectorIsDisabled(key) {
      return this.disabled || this.selectorAvailability?.[key] === false
    },
    selectorIsSelected(key) {
      if (key === this.schedulingBehavior) return true
      if (key === 'sequential' && this.isSequential) return true
      return false
    },
  },
}
</script>
